var FcSegmentOutlinedSelectModule = /** @class */ (function () {
    function FcSegmentOutlinedSelectModule() {
    }
    return FcSegmentOutlinedSelectModule;
}());
export { FcSegmentOutlinedSelectModule };
